/**
 * Sell-out vendor channels the portal hides: not selectable, not decoded, not mapped. Series keys.
 * Hälsokraft's sell-out feed arrived incomplete (2026-10-16); the keys lift out once it is whole.
 */
export const HIDDEN_PORTAL_VENDORS: ReadonlySet<string> = new Set([
  'halsokraft_se',
  'halsokraft_se-retail',
]);
